import { render, staticRenderFns } from "./template/modal-add-new-boat.html?vue&type=template&id=48abbaee&external"
import script from "./ModalAddNewBoat.vue?vue&type=script&lang=js"
export * from "./ModalAddNewBoat.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewBoat.vue?vue&type=style&index=0&id=48abbaee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports